import { mutationFor, queryFor } from "@visioni/a3s-client-api/app";
import { getUpsellStatusEndpoint, submitUpsellRequestEndpoint, upsellStatusResource } from "../client-messages/upsell";

export { upsellStatusResource };

/**
 * React Query options factory for the upsell status endpoint.
 *
 * Returns a function `(apiConfig, pathParams, queryParams)` that produces a
 * TanStack-Query options object with the queryKey, queryFn, and decode
 * boundary all derived from the endpoint definition. Callers spread the
 * result into `useQuery` and add their own UX flags (enabled, staleTime,
 * etc).
 *
 * Pattern mirrored from `features/a3s-traffic-flow/src/app/queries.ts`.
 */
export const upsellStatusQuery = queryFor(getUpsellStatusEndpoint);

/**
 * React Query mutation options factory for submitting an upsell request.
 *
 * Returns a function `(apiConfig, pathParams)` that produces a
 * TanStack-Query mutation options object — callers spread it into
 * `useMutation` and add their own `onSuccess` / `onError` handlers.
 */
export const submitUpsellRequestMutation = mutationFor(submitUpsellRequestEndpoint);
